import { z } from 'zod';
import { AccountSchema } from '../../../../entities/account/account.schema';
/**
 * Creating a customer. Both fields are optional because an account exists as
 * soon as somebody IS a customer — which can precede knowing their company id,
 * and certainly precedes knowing whose group they belong to.
 */ export const AddAccountRequestSchema = z.object({
    /**
   * The HubSpot company this customer is. Always the id, never a name — see
   * `Account.hubspotCompanyId` for what a name-based lookup once cost.
   */ hubspotCompanyId: z.string().optional(),
    parentAccountId: z.string().optional()
});
export const AddAccountResponseSchema = z.object({
    account: AccountSchema
});

//# sourceMappingURL=add-account.schema.js.map